import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { StatusBadge } from '../components/StatusBadge';

export function ProfilePage() {
  const { user } = useAuth();

  if (!user) {
    return <p className="muted">No profile loaded.</p>;
  }

  return (
    <section className="account-stage">
      <div className="account-card profile-card">
        <header className="account-card-header">
          <p className="brand-mark">Your account</p>
          <h2>Profile</h2>
          <p>Identity details for the signed-in admin session.</p>
        </header>

        <div className="profile-body">
          <dl className="profile-fields">
            <div>
              <dt>Full name</dt>
              <dd>{user.fullName}</dd>
            </div>
            <div>
              <dt>Email</dt>
              <dd>{user.email}</dd>
            </div>
            <div>
              <dt>Role</dt>
              <dd>
                <code>{user.role}</code>
              </dd>
            </div>
            {user.schoolId ? (
              <div>
                <dt>School ID</dt>
                <dd>
                  <code>{user.schoolId}</code>
                </dd>
              </div>
            ) : null}
            <div>
              <dt>Status</dt>
              <dd>
                <StatusBadge status={user.status} />
              </dd>
            </div>
          </dl>

          <div className="profile-actions">
            <Link className="primary-btn account-submit" to="/settings#change-password">
              Change password
            </Link>
            <Link className="ghost-btn account-secondary" to="/settings">
              Open settings
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
